interface CpeDocumentMap {
	[key: string]: string;
}

export const CpeDocData = [
	{
		type: 'car_registration',
		description: '¿Tienes el documento de registro del vehículo que prueba la propiedad?',
	},
	{
		type: 'drivers_license',
		description: '¿Cuentas con una licencia de conducir válida del conductor principal?',
	},
	{
		type: 'additional_drivers_license',
		description: '¿Tienes una licencia de conducir adicional para otros conductores autorizados?',
	},
	{
		type: 'bank_statement',
		description: '¿Puedes proporcionar un estado de cuenta bancario reciente para la verificación del pago?',
	},
	{
		type: 'bill_of_sale',
		description: '¿Tienes el contrato de compraventa del vehículo?',
	},
	{
		type: 'birth_certificate',
		description: '¿Puedes proporcionar tu certificado de nacimiento para la verificación de identidad?',
	},
];

export const CpeDocList: CpeDocumentMap = CpeDocData.reduce((acc, item) => {
	acc[item.type] = item.description;
	return acc;
}, {} as CpeDocumentMap);
